import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {ManifestationV4} from '../types';
import {selectMetadataEditSavedMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useSavedManifestation = (
  manifestationId: string,
): ManifestationV4 => {
  const manifestation = useAppSelector(
    useCreateSelectorById(
      manifestationId,
      selectMetadataEditSavedMetadataManifestationById,
    ),
  );

  if (!manifestation) {
    assert(false, 'useSavedManifestation: unknown manifestationId', {
      manifestationId,
    });
  }

  return manifestation;
};
